/**
 * Created by intellicar-rinas on 22/12/17.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import './LeftTree.css';
import Dom from '../../helpers/Dom';
import actions from '../../store/actions'
import moment from 'moment';
import {dateFormat} from '../../constants/constants';
import {JSONToCSVConvertor, bulkReqTracker} from '../../helpers/helperFunctions';
import GeofenceAPIs from '../../APIs/GeofenceAPIs';
import Map from '../InMap/Map/Map';
import { data } from 'jquery';
import GeoCodeAPIs from '../../APIs/GeoCodeAPIs'


class LeftTree extends Component {

    state = {
        vehicle:{},
        dGeofenceTree: [],
        geofenceTree: [],
        socVehicles: [],
        geoDownload: false,
        loading:false,
        clickedNode:null,
        isShowUsers: false,
        downloading: true,
    };

    constructor(){
        super();
        this.LatLngList = []
        this.splitedLatLng = []
        this.APIcount = 0
        this.tempLatLang = []
        this.allAddr = []
        
        this.toggleExpand =(node, vehiclesEnabled, usersEnabled)=> {
            if(this.state.loading) 
                return
            if(this.props.leftTree === 3)this.setState({loading:true,clickedNode : node.data.id})
            if(node.vehicleid) {
                this.setState({vehicle:node});
                if(window.setClickedVehicle) {
                    window.setClickedVehicle(node);
                }
            } else if (node.userid) {
                this.setState({vehicle:node});
                if(window.setClickedVehicle) {
                    window.setClickedVehicle(node);
                }
            } else {
                if(this.isExpandable(node, vehiclesEnabled, usersEnabled)) {
                    node.expanded = !node.expanded;
                }
            }
            if(node && node.data && node.data.id){this.updateGeofences(node.data.id,node)}
            this.forceUpdate();
        };

        this.isExpandable =(node, vehiclesEnabled, usersEnabled)=> {
            return  (node.children && node.children.length) ||
                    (node.vehicles && node.vehicles.length && vehiclesEnabled) ||
                    (node.users && node.users.length && usersEnabled)
        };

        this.getIcon = (node, vehiclesEnabled, usersEnabled) => {
            if(this.isExpandable(node, vehiclesEnabled, usersEnabled)) {
                return <span className={'lttn-icon fa ' + (node.expanded ? 'fa-chevron-down' : 'fa-chevron-right')}></span>
            }else if(node.vehicleid) {
                return <span className='lttn-icon -blue fa fa-car'></span>
            }else if(node.type === 'user') {
                return <span className='lttn-icon -green fa fa-user'></span>
            } else {
                return <span className='lttn-icon fa  fa-chevron-right -disabled'></span>
            }
        };

        this.makeChildStateSameToNode =(node, state)=> {
            node.checked = state;
            if(node.children) {
                for(let idx in node.children) {
                    this.makeChildStateSameToNode(node.children[idx], state);
                }
            }
        };

        this.makeParentStateSameToNode =(node, state)=> {
            if(state && node && node.ppath) {
                let ppathArr = node.ppath.split('/');
                let currentNode = this.props.groupTree;
                for(let idx in ppathArr) {
                    currentNode.checked = true;
                    for(let jdx in currentNode.children) {
                        if(currentNode.children[jdx].groupid == ppathArr[parseInt(idx, 10) + 1]) {
                            currentNode = currentNode.children[jdx];
                            break;
                        }
                    }
                }
            }

        };
        
        let checkedData = [];
        this.checked = (group,next) => {
            let ndx = next; 
            let checkedItems = {};
            let groupChildren = {};
            for (let idx in group){
                if (group[idx].checked === true && group[idx].path !== undefined){
                    checkedItems[ndx] = {
                        path : group[idx].path,
                    }
                    checkedData.push(checkedItems[ndx]); 
                }
                if(group[idx].children && group[idx].children.length != 0){
                    groupChildren = group[idx].children
                    this.checked(groupChildren,ndx)
                }    
            }
        }
        this.toggleCheck =node=> {
            let parentNode = this.props.groupTree;
            let next = 0;
            let groups = parentNode.children
            node.checked = !node.checked;
            this.makeChildStateSameToNode(node, node.checked);
            // stop 'check'ing ancestors
            // this.makeParentStateSameToNode(node, node.checked);
            this.checked(groups,next);
            localStorage.setItem("checkpath", JSON.stringify(checkedData))
            this.forceUpdate();
            this.props.dispatch({
                type:actions.CALCULATE_ALLOWED_VEHICLES,
                data:this.props.groupTree
            });
            checkedData = [];
            window.triggerSingleSearch(10);
        };

        this.getCheckBox =node=> {
            if(!node.groupid)
                return;

            return (
                <div className="lttn-checkbox" onClick={()=>this.toggleCheck(node)}>
                    {
                        node.checked ? (
                            <span className='fa fa-check-square'></span>
                        ) : (
                            // <span className='fa fa-square-o'></span>
                            <span><input type="checkbox" style={{color: "#ccc", cursor:"pointer" }}></input></span>
                        )
                    }
                </div>
            )

        };

        this.onVehicleChange =vehicle=> {
            this.setState({vehicle});
        };

        window.addVehicleListener('leftTree', this.onVehicleChange);

        this.changeTab =(index, geoid=null)=> {
            if(document.querySelector('.lt-tree-node.actv')){
                document.querySelector('.lt-tree-node.actv').classList.remove('actv')
            }
            if(index === 1){
                document.querySelector('.LeftTree-container').scrollTop = document.querySelector('.LeftTree-container').offsetTop - 40
            }
            if(index === 2) {
                this.setState({DGRefreshing: false});
                this.updateDGeofences();
                setTimeout(()=> {
                    this.setState({DGRefreshing: true});
                }, 100);
            }

            if(index === 3) {
                this.setState({GRefreshing: false});
                this.updateGeofences(geoid);
                setTimeout(()=> {
                    this.setState({GRefreshing: true}); 
                }, 100);
            }
            if(index === 4 ) {
                // this.updateSocVehicles(this.props.socSorted)
                
                // document.querySelector('.LeftTree-container').scrollTop = document.querySelector('.LeftTree-container').offsetTop + 90
             }

            this.props.dispatch({
                type:actions.TOGGLE_LEFT_TREE,
                data:index
            });
            if(index === 3 && geoid !=null ) {
                document.querySelector('.LeftTree-container.right2').scrollTop = document.getElementById(geoid).offsetTop + 30;
                document.getElementById(geoid).classList.add('actv');
             }
             
        };

        window.changeLeftTreeTab = this.changeTab;
        /*
        *
        *
        *
        * Geofences
        *
        *
        *
        * */

        this.updateGeofences =(geoid=null,node)=> {
            if(!this.geofenceMap || !this.geofenceMap.data)
                return;
            let geofences = this.geofenceMap.data;
            if(!this.state.geofenceTree.children){
                let geofenceTree = {
                    name: 'All Geofences',
                    children:[],
                    expanded:true,
                    button: [
                        {
                            onClick:(e, item, node)=> downloadAllGeofence(e, node),
                            icon: 'fa fa-download'
                        },
                        {
                            onClick:(e,item,node) => resetExpand(e,node),
                            icon:  'fa fa-expand'
                        }
                    ],
                    id:1,
                };
                let geo;
                let vehicle;
                let allGeofencesVehicleCount = 0;

                const isPointInsideCircle =(point, poly)=> {
                    let x = point.x - poly.x;
                    let y = point.y - poly.y;
                    console.log(Math.sqrt((x*x) + (y*y)), poly.r)
                    return Math.sqrt((x*x) + (y*y)) < poly.r; 
                }

                let fenceMap = {};

                for(let idx in geofences) { 
                    
                    if(geofences[idx].id in fenceMap) {
                        continue;
                    } else {
                        fenceMap[geofences[idx].id] = geofences[idx].id;
                    }
                    geo = {
                        name:geofences[idx].name,
                        id:geofences[idx].uid,
                        data:geofences[idx],
                        button:  [
                            {
                                onClick:(e, item, node)=>downloadGeofence(e, node),
                                icon: 'fa fa-download'
                            },
                            {
                                onClick:gotoGeofence,
                                icon: 'fa fa-map-marker'
                            }
                        ],
                        // expanded:geoid === null ? true :  geoid === geofences[idx].id ? true : false,
                        expanded: true,
                        vehicles: []
                    };
                    if(geofences[idx].id === geoid) {
                        for(let jdx in this.props.vehicleMap) {
                            vehicle = this.props.vehicleMap[jdx]; 
                            if(vehicle.stats && vehicle.markerVisible && vehicle.stats.lat && vehicle.stats.lng) {
                                if(geofences[idx].polygon && geofences[idx].polygon.containsLatLng(new window.google.maps.LatLng(vehicle.stats.lat, vehicle.stats.lng))) {
                                    geo.vehicles.push(vehicle);
                                }
                            }
                        }
                    }
                    // for(let jdx in this.props.vehicleMap) {
                    //     vehicle = this.props.vehicleMap[jdx]; 
                    //     if(vehicle.stats && vehicle.markerVisible && vehicle.stats.lat && vehicle.stats.lng) {
                    //         if(geofences[idx].polygon && geofences[idx].polygon.containsLatLng(new window.google.maps.LatLng(vehicle.stats.lat, vehicle.stats.lng))) {
                    //             geo.vehicles.push(vehicle);
                    //         }
                    //     }
                    // }
                    geo.name = geo.name + (geo.vehicles.length ? " (" + geo.vehicles.length + ")" : "");
                    allGeofencesVehicleCount += geo.vehicles.length;
                    geofenceTree.children.push(geo);
                }
                // geofenceTree.name = geofenceTree.name + " (" + allGeofencesVehicleCount + ")";
                this.setState({geofenceTree},() => {
                });

                // this.processVehicleLastEntryTime(geofenceTree);
            }else {
                let geoTree = this.state.geofenceTree.children
                let geofenceTrees = this.state.geofenceTree
                for(let idx in geoTree) { 
                    if(geoTree[idx].data.id === geoid) {
                        this.lastClicked = idx
                        if(geoTree[idx].vehicles.length){
                            geoTree[idx].vehicles = []
                        }
                        for(let jdx in this.props.vehicleMap) {
                        let vehicle = this.props.vehicleMap[jdx]; 
                            // console.log("vehicle",vehicle)
                            if(vehicle.stats && vehicle.markerVisible && vehicle.stats.lat && vehicle.stats.lng) {
                                // console.log("inside stats")
                                if(geoTree[idx].data.polygon && geoTree[idx].data.polygon.containsLatLng(new window.google.maps.LatLng(vehicle.stats.lat, vehicle.stats.lng))) {
                                    geoTree[idx].vehicles.push(vehicle);
                                }
                            }
                            geoTree[idx].name = geoTree[idx].data.name + (geoTree[idx].vehicles.length ? " (" + geoTree[idx].vehicles.length + ")" : "(0)");
                        }
                    }
                }
                geofenceTrees.children = geoTree
                this.processVehicleLastEntryTime(geoTree,node.expanded);
                this.setState({geofenceTree: geofenceTrees})
            }

        }
        

        this.processVehicleLastEntryTime =(gtree,expanded)=> {
            let reqArr = [];
            this.lastClicked = parseInt(this.lastClicked)
            let node = gtree[this.lastClicked]
            let vehicleid = (node.vehicles || []).map(i=> i.vehicleid);
            let body =  {
                reportid: node.data.reportid,
                fenceid: node.data.fenceid,
                vehicleid,
                // key: idx                    
            }
           

            const handleSuccess =(resp, report)=> {
             
                for(let jdx in resp) {
                    this.props.vehicleMap[jdx].lastGeofenceEntryInfo = {
                        time: resp[jdx]
                    }
                }
                this.setState({geofenceTree: this.state.geofenceTree, loading: false});
            }   
            if(vehicleid.length && expanded){
                GeofenceAPIs.getLastEntryTime(body)
                .then(handleSuccess)
            }else{
                this.setState({loading:false})
            }
           
            // bulkReqTracker(reqArr, handleSuccess);
        };


        const getLastCommTime = (stats) => {
            return moment(stats.utctime).format(dateFormat);
        };


        const getMobiliStatus = (mobilistatus) => {
            if (mobilistatus == 0) {
                return 'Active';
            } else if (mobilistatus == 1) {
                return 'Crank Immobilized';
            } else if (mobilistatus == 2) {
                return 'Ignition Immobilized';
            } else if (mobilistatus == 3) {
                return 'Crank & Ignition Immobilized';
            }
            return 'Unknown';
        };

        const getGeofenceDownloadData =geofences=> {
            let list = [];
            let name = geofences.name;
            name = name.substring(0, name.indexOf('('))
            let vehicle;
            for(let idx in geofences.vehicles) {
                vehicle = geofences.vehicles[idx];
                list.push({
                    'Geofence Name': name || geofences.name,
                    "Vehicle No": vehicle.vehicleno,
                    "DEVICE ID": vehicle.devices.TRACKER ? vehicle.devices.TRACKER.deviceno : 'No Tracker Device',
                    "KLE ID": vehicle.devices.LOCK_UNLOCK ? vehicle.devices.LOCK_UNLOCK.deviceno : 'No KLE Device',
                    "Chassis No": vehicle.vehiclemeta.chassisno  ? vehicle.vehiclemeta.chassisno : 'NA',
                    "Model": vehicle.vehiclemeta.model,
                    "Last comm time": getLastCommTime(vehicle.stats),
                    "Last Enty" : vehicle.lastGeofenceEntryInfo &&  vehicle.lastGeofenceEntryInfo.time ?  moment(vehicle.lastGeofenceEntryInfo.time).format(dateFormat) :"NA",
                    "GPS time": vehicle.stats.gpstime != null &&  vehicle.stats.gpstime != 'NA' ? moment(vehicle.stats.gpstime).format(dateFormat) : 'NO_GPSTIME',
                    "CAN Time": vehicle.stats.cantime != null && vehicle.stats.cantime != 'NA' ? moment(vehicle.stats.cantime).format(dateFormat) : 'NO_CANTIME',
                    "KLE Time": vehicle.stats.kletime != null &&  vehicle.stats.kletime != 'NA' ? moment(vehicle.stats.kletime).format(dateFormat) : 'NO_KLETIME',
                    "Odoemter Calculated From": vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom ? vehicle.vehiclemeta.odofrom : 'Not Set',
                    "Odometer CAN": isNaN(vehicle.stats.canOdometerFinal) ? 'NA' : vehicle.stats.canOdometerFinal,
                    "Odometer GPS": isNaN(vehicle.stats.gpsOdometerFinal) ? 'NA' : vehicle.stats.gpsOdometerFinal,
                    "Fuel Level (%)": vehicle.stats.fuel,
                    "Mobility": getMobiliStatus(vehicle.stats.mobilistatus),
                    "Ignition": vehicle.stats.ignitionstatus ? 'On' : "Off",
                    "Vehicle Battery": vehicle.stats.carbattery,
                    "Device Battery": vehicle.stats.devicebattery,
                });
            }
            return list;
        };

        const downloadAllDgeofence =(e, node)=> {
            let data = [];
            var d = new Date();
            var date = d.getDate()+'_'+(d.getMonth()+1)+'_'+d.getFullYear();
            for(let idx in node.children) {
            data = [...data, ...getGeofenceDownloadData(node.children[idx])];
            }
            JSONToCSVConvertor(data, 'All Geofence Report_'+date);
        };
        const downloadDgeofence =(e, node)=> {
            var d = new Date();
            var date = d.getDate()+'_'+(d.getMonth()+1)+'_'+d.getFullYear();
            let name = node.name.substring(0, node.name.indexOf('('))
            JSONToCSVConvertor(getGeofenceDownloadData(node), name + '_Geofence_report_' + date);
        };
        const downloadAllGeofence =(e, node)=> {
            this.setState({geoDownload: true})
            document.getElementsByClassName('MainLayout')[0].style.pointerEvents = 'none'
            let data = [];
            var d = new Date();
            let geofences = this.geofenceMap.data;
            var date = d.getDate()+'_'+(d.getMonth()+1)+'_'+d.getFullYear();
            setTimeout(() => {
                let geofenceTree = {
                    name: 'All Geofences',
                    children:[],
                    expanded:true,
                    button: [
                        {
                            onClick:(e, item, node)=> downloadAllGeofence(e, node),
                            icon: 'fa fa-download'
                        },
                        {
                            onClick:(e,item,node) => resetExpand(e,node),
                            icon:  'fa fa-expand'
                        }
                    ],
                    id:1,
                };
                let geo;
                let vehicle;
    
                let fenceMap = {};
    
                for(let idx in geofences) { 
                    
                    if(geofences[idx].id in fenceMap) {
                        continue;
                    } else {
                        fenceMap[geofences[idx].id] = geofences[idx].id;
                    }
                    geo = {
                        name:geofences[idx].name,
                        id:geofences[idx].uid,
                        data:geofences[idx],
                        button:  [
                            {
                                onClick:(e, item, node)=>downloadGeofence(e, node),
                                icon: 'fa fa-download'
                            },
                            {
                                onClick:gotoGeofence,
                                icon: 'fa fa-map-marker'
                            }
                        ],
                        vehicles: []
                    };
                   
                    for(let jdx in this.props.vehicleMap) {
                        vehicle = this.props.vehicleMap[jdx]; 
                        if(vehicle.stats && vehicle.markerVisible && vehicle.stats.lat && vehicle.stats.lng) {
                            if(geofences[idx].polygon && geofences[idx].polygon.containsLatLng(new window.google.maps.LatLng(vehicle.stats.lat, vehicle.stats.lng))) {
                                geo.vehicles.push(vehicle);
                            }
                        }
                    }
                    geofenceTree.children.push(geo);
                }
                for(let idx in geofenceTree.children) {
                    data = [...data, ...getGeofenceDownloadData(geofenceTree.children[idx])];
                }
                this.setState({geoDownload: false})
                document.getElementsByClassName('MainLayout')[0].style.pointerEvents = "auto"
                JSONToCSVConvertor(data, 'All Geofence Report_'+date);
            },1000)
            
        };
        const processSocVehicles = (vehicles) => {
            let list = [];
            let vehicle;
            for(let idx in vehicles) {
                vehicle = vehicles[idx];
                this.LatLngList.push([vehicle.stats.lat, vehicle.stats.lng]);

                list.push({
                    "Vehicle No": vehicle.vehicleno,
                    "DEVICE ID": vehicle.devices.TRACKER ? vehicle.devices.TRACKER.deviceno : 'No Tracker Device',
                    "KLE ID": vehicle.devices.LOCK_UNLOCK ? vehicle.devices.LOCK_UNLOCK.deviceno : 'No KLE Device',
                    "Chassis No": vehicle.vehiclemeta.chassisno  ? vehicle.vehiclemeta.chassisno : 'N/A',
                    "Model": vehicle.vehiclemeta.model,
                    "Last comm time": getLastCommTime(vehicle.stats),
                    "GPS time": vehicle.stats.gpstime != null &&  vehicle.stats.gpstime != 'N/A' ? moment(vehicle.stats.gpstime).format(dateFormat) : 'NO_GPSTIME',
                    "CAN Time": vehicle.stats.cantime != null && vehicle.stats.cantime != 'N/A' ? moment(vehicle.stats.cantime).format(dateFormat) : 'NO_CANTIME',
                    "KLE Time": vehicle.stats.kletime != null &&  vehicle.stats.kletime != 'N/A' ? moment(vehicle.stats.kletime).format(dateFormat) : 'NO_KLETIME',
                    "Odoemter Calculated From": vehicle.vehiclemeta && vehicle.vehiclemeta.odofrom ? vehicle.vehiclemeta.odofrom : 'Not Set',
                    "Odometer CAN": isNaN(vehicle.stats.canOdometerFinal) ? 'N/A' : vehicle.stats.canOdometerFinal,
                    "Odometer GPS": isNaN(vehicle.stats.gpsOdometerFinal) ? 'N/A' : vehicle.stats.gpsOdometerFinal,
                    "Fuel Level (%)": vehicle.stats.fuel,
                    "Mobility": getMobiliStatus(vehicle.stats.mobilistatus),
                    "Ignition": vehicle.stats.ignitionstatus ? 'On' : "Off",
                    "Vehicle Battery": vehicle.stats.carbattery,
                    "Device Battery": vehicle.stats.devicebattery,
                    'Battery Temperature': vehicle.GPS.battmp || 'N/A',
                    "Cell temperature" : vehicle.stats.cellTemp ? vehicle.stats.cellTemp : '' ,
                    'SOH': vehicle.GPS.soh || 'N/A',
                    'Charge Cycle': vehicle.GPS.chc || 'N/A',
                    'KWH': vehicle.GPS.kwh || 'N/A',
                    'Current' : vehicle.GPS.cr || 'N/A',
                    'controller Temperature' : vehicle.GPS.ctrtmp || 'N/A',
                    'Address':vehicle.stats.address || 'N/A'
                });
            }
            return list;
        }
        const downloadSocVehicles = () => {
            let title = this.props.lockUnlock && this.props.lockUnlock.clicked ? this.props.lockUnlock.key + "_vehicles" : "soc vehicles"
            let prodata = processSocVehicles(this.state.socVehicles.children)
            const auth = window.getAuth();
            let splitLimit = 50;
            if (this.LatLngList.length > splitLimit) {
              let startIndex = 0;
              let endindex = startIndex + splitLimit;
              this.count = Math.ceil(this.LatLngList.length / splitLimit);
              for (let split = 0; split < this.count; split++) {
                let page = [];
                for (let idx in this.LatLngList) {
                  if (idx >= startIndex && idx < this.LatLngList.length && idx < endindex)
                    page.push(this.LatLngList[idx]);
                }
                this.splitedLatLng.push(page);
                startIndex = endindex;
                endindex =
                  startIndex + splitLimit > this.LatLngList.length
                    ? this.LatLngList.length
                    : startIndex + splitLimit;
              }
            } else {
              this.count = 1;
              this.splitedLatLng[0] = this.LatLngList;
            }

            const handleAddressFailure = (error) => {
                console.log("calling error");
                console.log(error);
                this.APIcount = this.APIcount + 1;
              };
             
            const callApis = (body, index) => {
                index = parseInt(index, 10);
                GeoCodeAPIs.getAddress(body).then((resp) => {
                  this.APIcount = this.APIcount + 1;
                  if (resp !== undefined) {
                    this.tempLatLang[index] = resp;
                    if (index + 1 < this.splitedLatLng.length)
                      callApis(this.splitedLatLng[index + 1], index + 1);
                  } else {
                    let tempArr = [];
                    for (let idx in this.splitedLatLng[index]) {
                      tempArr.push([[], "NA"]);
                    }
                    this.tempLatLang[index] = tempArr;
                    if (index + 1 < this.splitedLatLng.length)
                      callApis(this.splitedLatLng[index + 1], index + 1);
                    if (!window.addrFailed) {
                      props.dispatch({
                        type: "ADD_INTOAST",
                        data: {
                          name: "Error Fetching Some Recent Locations",
                          content: "Unable to fetch a few recent locations",
                          createAt: Date.now(),
                          autoClose: 8000,
                          showError:true
                        },
                      });
                      window.addrFailed = true;
                    }
                  }
                  if (this.APIcount === this.count) {
                    this.tempLatLang.map((data) => {
                      this.allAddr = this.allAddr.concat(data);
                    });
                    for (let idx in prodata) {
                      // console.log(allAddr)
                      prodata[idx]["Last Location"] = this.allAddr[idx][1];
                    }
                    JSONToCSVConvertor(prodata, "ViewReport", true);
                    this.LatLngList = []
                    this.splitedLatLng = []
                    this.APIcount = 0
                    this.tempLatLang = []
                    this.allAddr = []
                  }
                }, handleAddressFailure);
              };
            
              callApis(this.splitedLatLng[0], 0);

            // JSONToCSVConvertor(processSocVehicles(this.state.socVehicles.children),title)
        }
        const resetExpand = (e,node) => {
            if(node.children){
               let rows = node.children;
                for(let idx in rows){
                    if(rows[idx].expanded === true) {
                        rows[idx].expanded = !rows[idx].expanded;
                        document.querySelector('.lttn-button .fa.fa-expand').style.color = '#fc5132';
                        this.setState({node})
                    }else {
                        rows[idx].expanded = !rows[idx].expanded;
                        document.querySelector('.lttn-button .fa.fa-expand').style.color = '#999';
                        this.setState({node})
                    }
                }
            }
        }

        const downloadGeofence =(e, node)=> {
            var d = new Date();
            var date = d.getDate()+'_'+(d.getMonth()+1)+'_'+d.getFullYear();
            let name = node.name.substring(0, node.name.indexOf('('))
            JSONToCSVConvertor(getGeofenceDownloadData(node), name + '_Geofence_report_' + date);
        };

        const gotoGeofence =(e, item, node)=> {
            let bounds = new window.google.maps.LatLngBounds();
            if(window.map) {
                let info = node.data.info.coords;
                let latLng = node.data.info.center;
                if(node.data.info.structure === 'circle'){
                    window.map.setCenter(latLng);
                    if(node.data.info.radius < 500){
                        window.map.setZoom(17);
                    }
                    else if(node.data.info.radius < 3000){
                        window.map.setZoom(14);
                    }
                    else if(node.data.info.radius < 6000){
                        window.map.setZoom(12);
                    }
                    else if(node.data.info.radius > 6000){
                        window.map.setZoom(10);
                    }
                }else {
                    let coords;
                    for(let idx in info) {
                        coords = info[idx];
                        bounds.extend(new window.google.maps.LatLng(coords.lat, coords.lng));
                    }
                    window.map.fitBounds(bounds);
                }
                
           //     this.map.fitBounds(bounds)
                // console.log("info goto geofence",info)
               // let center = info.center || info.latLng || ((info.coords || [])[0]);
                // if(center) {
                //     window.map.setCenter(center);
                //     window.map.setZoom(18);
                // }
            }
        }

        this.updateDGeofences =()=> {
            let geofences = this.DGeofence.geofences || [];
            let dGeofenceTree = {
                name: 'All Geofences',
                children:[],
                expanded:true,
                button: {
                    onClick:downloadAllDgeofence,
                    icon: 'fa fa-download'
                },
                id:1,
            };
            let geo;
            let vehicle;
            let allGeofencesVehicleCount = 0;
            for(let idx in geofences) {
                geo = {
                    name:geofences[idx].name,
                    id:geofences[idx].uid,
                    data:geofences[idx],
                    button: {
                        onClick:downloadDgeofence,
                        icon: 'fa fa-download',
                    },
                    expanded:true,
                    vehicles: []
                };

                for(let jdx in this.props.vehicleMap) {
                    vehicle = this.props.vehicleMap[jdx];
                    if(vehicle.stats && vehicle.markerVisible && vehicle.stats.lat && vehicle.stats.lng &&
                        geofences[idx].poly.containsLatLng(vehicle.stats.lat, vehicle.stats.lng)) {
                        geo.vehicles.push(vehicle);
                    }

                }
                geo.name = geo.name + " (" + geo.vehicles.length + ")";
                allGeofencesVehicleCount += geo.vehicles.length;
                dGeofenceTree.children.push(geo);
            }

            dGeofenceTree.name = dGeofenceTree.name + " (" + allGeofencesVehicleCount + ")";
            this.setState({dGeofenceTree});
        };
        this.updateSocVehicles = (props) => {
            let socSorted = props.socSorted || [];
            let searchSorted = []
            if(props && socSorted.length && props.searchString && props.searchResult.length){
                searchSorted = props.searchResult.filter(item1 =>
                    props.socSorted.some(item2 => item2.vehicleno === item1.vehicleno)
                );
            }
            let socVehicles = {
                name: props.lockUnlock && props.lockUnlock.clicked && props.lockUnlock.key === "lock" ?
                "Locked Vehicles" : props.lockUnlock && props.lockUnlock.clicked && props.lockUnlock.key === "unlock" ? "Unlocked Vehicles" : 'SoC Vehicles',
                children: props.searchString ? searchSorted :  socSorted,
                expanded:true,
                button: {
                    onClick:downloadSocVehicles,
                    icon: 'fa fa-download'
                },
                id:1,
            };
            
            this.setState({
                socVehicles :socVehicles
            })
        }

        this.getButton =node=> {
            if(node.button && node.button.length != null) {
                return node.button.map((item, index)=> {
                    return (
                        <div className="lttn-button" key={index} style={{right: parseInt(index, 10) * 30}} onClick={e=>item.onClick(e, item, node)}><i className={item.icon}></i></div>
                    )
                })
            }else if(node.button) {
                return (
                    <div className="lttn-button" onClick={e=>node.button.onClick(e, node)}><i className={node.button.icon}></i></div>
                )
            }
        };

    }

    // this.geofenceTree
    componentDidMount() {
        if(this.props.auth && this.props.auth.userinfo && this.props.auth.userinfo.userid && this.props.auth.userinfo.userid === 8812 ){
            this.setState({isShowUsers: true})
        }
    }

    componentWillReceiveProps(props){
        if(props.leftTree === 0){
            this.setState({geofenceTree: []})
        }

        if(!this.DGeofence || !props.DGeofence || this.DGeofence.updatedAt < props.DGeofence.updatedAt) {
            this.DGeofence = props.DGeofence;
            this.updateDGeofences();
        }
        

        if(!this.geofenceMap || !props.geofenceMap || this.geofenceMap.updatedAt < props.geofenceMap.updatedAt) {
            this.geofenceMap = props.geofenceMap;
            this.updateGeofences();
        }
        if(props)this.updateSocVehicles(props)
        

    }
    // componentDidUpdate(props1,props2,props2) {
    //     console.log("calling props....",props1,props2,props3)
    // }

    getLastEntryTime =(node, vehiclesEnabled)=> {
        if(vehiclesEnabled === 2 && node.vehicleid) {
            let msg = node.lastGeofenceEntryInfo ? 'Last Entry : '+ moment(node.lastGeofenceEntryInfo.time).format(dateFormat) : 'Last Entry : N/A';
            return (
                <div>{msg}</div>
            )
        }
        return '';
    }

    treeBuilder(node, checkbox=true, vehiclesEnabled=false, usersEnabled=false, index=0){
        if(!node)
            return '';

        if(node.length != null) {
            return node.map((child, index)=>{
                return this.treeBuilder(child, checkbox, vehiclesEnabled, usersEnabled, index)
            })
        }
        return (
            
            <div className="lt-tree-node" key={index} id={(node.data) ? node.data.id : ''} >

                
                <div className={Dom.Class({'active':this.state.vehicle.id && this.state.vehicle.id === node.id}, "lttn-name")}>
                    <div className="lttn-expandButton" onClick={()=>this.toggleExpand(node, vehiclesEnabled, usersEnabled)}></div>
                    
                    {this.getIcon(node,  vehiclesEnabled, usersEnabled)}
                    {this.getButton(node)}
                    {this.props.leftTree === 3 && this.state.loading
                    && node.data && node.data.id && node.data.id === this.state.clickedNode ? 
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div> : null}
                    {/* {node.name || node.vehicleno || node.username} */}
                    {node.username ? node.username : node.name || node.vehicleno}
                    {checkbox ? this.getCheckBox(node) : ''}
                    {this.getLastEntryTime(node, vehiclesEnabled)}
                </div>
                
                {node.children && node.children.length && node.expanded ? (
                    <div className="lttn-children">{
                        node.children.filter(c=> { return c.groupid !== -1 }).map((child, index) => {
                            return this.treeBuilder(child, checkbox, vehiclesEnabled, usersEnabled, index);
                        })
                    }</div>
                ) : null}
                {vehiclesEnabled && node.vehicles && node.vehicles.length && node.expanded ? (
                    <div className="lttn-children">{
                        node.vehicles.map((child, index) => {
                            return this.treeBuilder(child, checkbox, vehiclesEnabled, usersEnabled, index);
                        })
                    }</div>
                ) : null}
                {usersEnabled && node.users && node.users.length && node.expanded ? (
                    <div className="lttn-children">{
                        node.users.map((child, index) => {
                            return this.treeBuilder(child, checkbox, vehiclesEnabled, usersEnabled, index);
                        })
                    }</div>
                ) : null}
            </div>
        )
    }

    render(){
        return (
            <div className={"LeftTree " + (this.props.leftTree && !this.props.reportWindow.visible && !this.props.tableView.active ? ' active ':'')}>
                <div className="LeftTree-tabs">
                    <div onClick={()=>this.changeTab(1)} className={"ltt-tab" + (this.props.leftTree === 1 ? ' active' : '')}>Groups</div>
                    <div onClick={()=>this.changeTab(2)} className={"ltt-tab" + (this.props.leftTree === 2 ? ' active' : '')}>
                        D-Geofences
                        <i className={"fa fa-refresh" + (this.state.DGRefreshing ? ' -refresh': '')}></i>
                    </div>
                    <div onClick={()=>this.changeTab(3)} className={"ltt-tab" + (this.props.leftTree === 3 ? ' active' : '')}>
                        Geofences
                        <i className={"fa fa-refresh" + (this.state.GRefreshing ? ' -refresh': '')}></i>
                    </div>
                   {this.props.socSorted && this.props.socSorted.length ? <div onClick={()=>this.changeTab(4)} className={"ltt-tab" + (this.props.leftTree === 4 ? ' active' : '')}>{this.props.lockUnlock && this.props.lockUnlock.clicked && this.props.lockUnlock.key === "lock" 
                        ? "Lock" : this.props.lockUnlock && this.props.lockUnlock.clicked && this.props.lockUnlock.key === "unlock"  ? "Unlock" : "SOC Vehicles"}</div>
                    :<div className={"ltt-tab disabled"} >SOC Vehicles</div>}
                </div>
                <div className={"LeftTree-container " + (this.props.leftTree === 2 ? ' right' : this.props.leftTree === 3 ? ' right2' : this.props.leftTree === 4 ? ' soc' :'')}>
                    <div className="LeftTree-inner">
                        {this.treeBuilder(this.props.groupTree, true, false, this.state.isShowUsers)}
                    </div>
                    <div className="LeftTree-inner">
                        {this.treeBuilder(this.state.dGeofenceTree, false, true, true)}
                    </div>
                    <div className="LeftTree-inner">
                        {this.state.geoDownload ? <div className='allDownloading'><span>All geofences are downloading. Please wait.</span> 
                        <div className="lds-ring"><div></div><div></div><div></div><div></div></div> </div> : null}
                        {this.treeBuilder(this.state.geofenceTree, false, 2, false)}
                    </div>
                    <div className="LeftTree-inner">
                        {this.treeBuilder(this.state.socVehicles, false, true, true)}
                    </div>
                </div>
            </div>
        )
    }

}

const mapPropsToState = state => {
    return {
        groupTree:state.groupTree,
        leftTree:state.leftTree,
        reportWindow:state.reportWindow,
        tableView:state.tableView,
        vehicleMap:state.vehicleMap,
        DGeofence:state.DGeofence,
        geofenceMap: state.geofenceMap,
        socSorted : state.socSorted,
        lockUnlock: state.lockUnlock,
        auth: state.auth,
        searchString: state.searchString,
        searchResult: state.searchResult,
    };
};

export default connect(mapPropsToState)(LeftTree);